module.exports = __webpack_public_path__ + "media/images/Crimean_pilaf-f398ccea4d484f17f69938b34a9c4b22.png";